import React, { useCallback, useEffect, useMemo, useRef, useState, } from "react";
import { useTranslation } from "../hooks/useTranslation";
import { keyPress } from "../utils/keyPress";
import { v4 as uuidv4 } from "uuid";
import { Dropdown, DropdownOptions, toCheckIfDisplayed, } from "../dropdown/Dropdown";
import { createUseStyles } from "react-jss";
import { THEME } from "../theming/theming";
export var TableDropdown = function (_a) {
    var dropdown = _a.dropdown, item = _a.item, tableId = _a.tableId, rowId = _a.rowId, dataId = _a.dataId, dataTestId = _a.dataTestId;
    var _b = useState(false), isDropdownOpen = _b[0], setIsDropdownOpen = _b[1];
    var dropdownRef = useRef(null);
    var handleClick = useCallback(function (event) {
        if (dropdownRef.current) {
            if (!dropdownRef.current.contains(event.target)) {
                setTimeout(function () { return setIsDropdownOpen(false); }, 100);
            }
        }
    }, [setIsDropdownOpen]);
    var keyFunctions = useCallback(function (event) {
        if (event.keyCode === keyPress.ESCAPE) {
            setIsDropdownOpen(false);
        }
    }, [setIsDropdownOpen]);
    useEffect(function () {
        if (isDropdownOpen) {
            document.addEventListener("keydown", keyFunctions, false);
            document.addEventListener("mousedown", handleClick);
        }
        return function () {
            if (isDropdownOpen) {
                document.removeEventListener("keydown", keyFunctions, false);
                document.removeEventListener("mousedown", handleClick);
            }
        };
    }, [handleClick, isDropdownOpen, keyFunctions]);
    var handleOptionSelection = function (option, ev, item) {
        ev.stopPropagation();
        setIsDropdownOpen(false);
        option.onClick && option.onClick(item);
    };
    var openDropdown = function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        setIsDropdownOpen(!isDropdownOpen);
    };
    var id = tableId || uuidv4();
    var dropdownId = "".concat(id, "__table-row-").concat(rowId, "__dropdown");
    var allOptionsHidden = useMemo(function () { return dropdown === null || dropdown === void 0 ? void 0 : dropdown.every(function (option) { return !toCheckIfDisplayed(option, item); }); }, [dropdown]);
    return (React.createElement("div", { className: "menu", "data-id": dataId, "data-testid": dataTestId },
        React.createElement(TableDropdownAction, { openDropdown: function (ev) { return openDropdown(ev); }, id: dropdownId, haspopup: !!dropdown, isDropdownOpen: isDropdownOpen, dataId: dataId, dataTestId: dataTestId, disabled: allOptionsHidden }),
        isDropdownOpen && (React.createElement(Dropdown, { ariaLabelledBy: dropdownId, dropdownRef: dropdownRef, dataHook: "table-dropdown-options" }, dropdown && (React.createElement(DropdownOptions, { options: dropdown, id: dropdownId, item: item, onChange: handleOptionSelection }))))));
};
export var TableDropdownAction = function (props) {
    var t = useTranslation();
    var classes = useTableDropdownClasses();
    return (React.createElement("button", { onClick: function (ev) { return (props === null || props === void 0 ? void 0 : props.openDropdown) && (props === null || props === void 0 ? void 0 : props.openDropdown(ev)); }, id: props === null || props === void 0 ? void 0 : props.id, "aria-haspopup": !!(props === null || props === void 0 ? void 0 : props.haspopup), "aria-expanded": !!(props === null || props === void 0 ? void 0 : props.isDropdownOpen), className: classes.button, "data-hook": "table-dropdown-button", "data-testid": (props === null || props === void 0 ? void 0 : props.dataTestId) && "".concat(props === null || props === void 0 ? void 0 : props.dataTestId, "-dropdownAction"), "data-id": (props === null || props === void 0 ? void 0 : props.dataId) && "".concat(props === null || props === void 0 ? void 0 : props.dataId, "-dropdownAction"), type: "button", disabled: props.disabled },
        React.createElement("span", { className: "sr-only" }, t("Row Menu")),
        React.createElement("span", { className: "glyphicon glyphicon-option-vertical" })));
};
export function useTableDropdownClasses() {
    var useStyles = createUseStyles({
        button: {
            backgroundColor: "transparent",
            padding: [6, 9],
            border: 0,
            fontSize: 14,
            color: THEME.palette.gray.slate.color,
            lineHeight: "1.2!important",
            display: "inline-block",
            cursor: "pointer",
            "&:active": {
                backgroundColor: THEME.palette.gray.fog.color,
                outline: 0,
            },
            "&:focus": {
                backgroundColor: THEME.palette.gray.fog.color,
                outline: "5px auto -webkit-focus-ring-color",
                outlineOffset: -2,
            },
            "&:disabled": {
                color: THEME.palette.gray.smoke.color,
            },
        },
    });
    return useStyles();
}
